//
//  SDKTokenGroupResolver.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { TokenGroup, } from "../../model/groups/SDKTokenGroup";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class TokenGroupResolver {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Configuration
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Resolution
    resolveGroupData(data) {
        const hashedGroups = new Map();
        const resolvedGroups = new Map();
        // Convert raw groups to resolved groups, not caring about the references just yet
        data.forEach((rawGroup) => {
            const group = new TokenGroup(rawGroup);
            // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
            hashedGroups.set(rawGroup.persistentId, rawGroup);
            // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
            resolvedGroups.set(rawGroup.persistentId, group);
        });
        // Build the reference tree and list of tokens
        data.forEach((rawGroup) => {
            const filteredTokenIds = new Array();
            // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
            const referencedGroup = resolvedGroups.get(rawGroup.persistentId);
            rawGroup.childrenIds.forEach((id) => {
                // Find if reference is group - if it is not, it is a token
                const childGroup = resolvedGroups.get(id);
                if (childGroup) {
                    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                    referencedGroup.addChild(childGroup.id);
                }
                else {
                    filteredTokenIds.push(id);
                }
            });
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            referencedGroup.tokenIds = filteredTokenIds;
        });
        // Retrieve resolved groups
        const groups = Array.from(resolvedGroups.values());
        this.recomputePaths(groups);
        this.recomputeParents(groups);
        return this.reorderGroupsByRoots(groups);
    }
    recomputePaths(groups) {
        // Find roots, and compute the segments down from the roots
        groups.forEach((group) => {
            if (group.isRoot) {
                this.recomputePathsFromRoot(group, [], groups);
            }
        });
        // Drop first item because we don't want the core root category to be there
        groups.forEach((group) => {
            group.path.shift();
        });
    }
    recomputePathsFromRoot(root, segments, groups) {
        // Recursively go down the tree(s) and add segments to each
        const extendedPath = segments.concat(root.name);
        root.subgroupIds.forEach((groupId) => {
            const group = groups.find((g) => g.id === groupId);
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            group.path = extendedPath.concat();
            // @ts-expect-error TS(2345): Argument of type 'TokenGroup | undefined' is not a... Remove this comment to see the full error message
            this.recomputePathsFromRoot(group, extendedPath, groups);
        });
    }
    reorderGroupsByRoots(groups) {
        let sortedGroups = new Array();
        // Find the root groups, which will be initial sorting points
        const roots = groups.filter((g) => g.isRoot);
        roots.forEach((root) => {
            // For each group, traverse and add proper order
            sortedGroups = sortedGroups.concat(this.traverseSortGroup(root, groups));
        });
        return sortedGroups;
    }
    traverseSortGroup(group, groups) {
        let output = new Array();
        // Iterated group always first
        output.push(group);
        // Add sorted groups to the array
        const sortedGroupIds = group.subgroupIds.sort((g1, g2) => group.childrenIds.indexOf(g1) - group.childrenIds.indexOf(g2));
        sortedGroupIds.forEach((subgroupId) => {
            const subgroup = groups.find((g) => g.id === subgroupId);
            // @ts-expect-error TS(2345): Argument of type 'TokenGroup | undefined' is not a... Remove this comment to see the full error message
            output = output.concat(this.traverseSortGroup(subgroup, groups));
        });
        return output;
    }
    recomputeParents(groups) {
        // Find roots, and compute the references down the chain. Root groups don't have parents
        groups.forEach((group) => {
            if (group.isRoot) {
                this.recomputeParentsFromRoot(group, groups);
                group.parentGroupId = null;
            }
        });
    }
    recomputeParentsFromRoot(rootGroup, groups) {
        rootGroup.subgroupIds.forEach((subgroupId) => {
            const subgroup = groups.find((g) => g.id === subgroupId);
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            subgroup.setParentGroupId(rootGroup.id);
            // @ts-expect-error TS(2345): Argument of type 'TokenGroup | undefined' is not a... Remove this comment to see the full error message
            this.recomputeParentsFromRoot(subgroup, groups);
        });
    }
}
